var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 66.294,
    height: 65.5,
    viewBox: "0 0 66.294 65.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3510",
    "data-name": "Rectangle 3510",
    width: 66.293,
    height: 65.5,
    fill: "#fcbf49"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10421",
    "data-name": "Group 10421",
    transform: "translate(-30.68 -92.758)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10420",
    "data-name": "Group 10420",
    transform: "translate(30.68 92.758)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10390",
    "data-name": "Group 10390",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27723",
    "data-name": "Path 27723",
    d: "M71,337.49l-3.248,2.843.207.237c.135.155.293.155.473,0l2.707-2.369c.181-.158.2-.316.068-.472Z",
    transform: "translate(-58.009 -288.966)",
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27724",
    "data-name": "Path 27724",
    d: "M60.509,228.371,56.4,225.02a23.255,23.255,0,1,1-46.51,0l-4.276,3.352L0,225.02a33.147,33.147,0,1,0,66.293,0ZM6.9,236.509l-1.294.943.5-1.523-1.3-.939,1.6,0L6.9,233.47,7.39,235l1.6,0-1.3.939.5,1.523Zm2.313,8.454-.924-1.057,4.768-4.174.96,1.1a1.171,1.171,0,0,1-.193,1.86l-2.709,2.371a1.193,1.193,0,0,1-1.9-.1m5.445,5.206-.834-.659.679-1.142-.608-.48-.955.923-.832-.657,1.639-1.589,3.028-2.8,1.074.848L15.83,248.2Zm2.565,1.628,3.185-5.479.91.529-3.183,5.479Zm6.656,1.958-.382.936-2.3-.939,2.4-5.866.975.4-2.016,4.93Zm4.51-.781-.035.062-.5,2.621-1.035-.2.5-2.617-.011-.073-.413-3.747,1.094.21.076,2.506,1-2.3,1.094.21Zm8.418,2.923-1.047.119-.719-6.3,2.466-.282.114,1-1.419.163.188,1.64,1.221-.139.115,1.006-1.221.139Zm6.187-1.387L41.378,252.2l-.055.019.937,2.561-.989.362-2.178-5.952,1.3-.474a1.171,1.171,0,0,1,1.666.85l.321.877a1.057,1.057,0,0,1-.265,1.282l1.957,2.392Zm3.869-1.615-2.772-5.7,2.231-1.086.443.907-1.285.625.723,1.485,1.1-.538.443.911-1.1.538.723,1.485,1.284-.626.441.909Zm5.921-3.663a1.212,1.212,0,0,1-1.922-.227L50.3,248.3l.828-.653.556.7q.222.28.467.086c.162-.127.17-.286.022-.472l-.439-.556q-.261-.332-1.258-.286a1.809,1.809,0,0,1-1.613-.643l-.359-.457a1.366,1.366,0,1,1,2.144-1.692l.556.7-.827.654-.558-.706c-.147-.185-.3-.214-.464-.089l-.006,0c-.16.127-.167.283-.019.472l.349.443q.239.3,1.236.257a1.791,1.791,0,0,1,1.6.624l.486.617a1.209,1.209,0,0,1-.221,1.921m4.387-4.51-2.034-1.717-.4.477,2.033,1.717-.679.805-4.842-4.089.68-.805,2.033,1.718.4-.477-2.034-1.717.68-.805,4.841,4.088Zm2.049-8.213-1.294.943.5-1.523-1.3-.939,1.6,0,.493-1.526L59.71,235l1.6,0-1.3.939.5,1.523Z",
    transform: "translate(0 -192.667)",
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27725",
    "data-name": "Path 27725",
    d: "M102.127,371.4l.989-1.662-1.386,1.349Z",
    transform: "translate(-87.103 -316.579)",
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27726",
    "data-name": "Path 27726",
    d: "M281.828,396.713q-.123-.338-.414-.233l-.224.082.568,1.551.119-.043a.832.832,0,0,0,.2-.094.324.324,0,0,0,.069-.387Z",
    transform: "translate(-240.761 -339.453)",
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27727",
    "data-name": "Path 27727",
    d: "M117.416,117.271c-.437,1.829.4,3.456,2.746,3.845,8.09,1.341,21.134,1.143,26.869-.446,2.807-.778,2.541-4.178,1.268-6.309-5.379-9.021-28.585-9.064-30.884,2.91m3.308-.081a12.458,12.458,0,0,0,4.5.451c.656-.119.562-.529-.091-.5a16,16,0,0,1-4.076-.512c-1.206-.437-.9-1.671.086-1.646a7.658,7.658,0,0,0,2.457-.247c-3.083-.808-1.649-2.46.495-3.5,5.134-2.483,18.7-2.25,21.8,2.738.906,1.534-1.251,1.908-1.714,2.16-.309.168-.312.526.183.52,3.451-.289,2.618.677,2.221.958a10.975,10.975,0,0,1-4.888,1.159c-.532.023-.227.459,0,.459a15.376,15.376,0,0,0,4.983-.682c1.009-.157,1.1.794.265.958-7.79,1.955-19.522,1.448-25.69.7-.979-.075-1-1.209.059-1.061a20.939,20.939,0,0,0,5.36.128c.4.014.41-.372.066-.4a16.039,16.039,0,0,1-6.247-.8c-.837-.252-.581-1.2.232-.884",
    transform: "translate(-100.439 -92.392)",
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27728",
    "data-name": "Path 27728",
    d: "M175.152,145.516a.444.444,0,0,0-.472-.416.45.45,0,0,0-.47.424.443.443,0,0,0,.47.416.452.452,0,0,0,.472-.424",
    transform: "translate(-149.162 -124.238)",
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27729",
    "data-name": "Path 27729",
    d: "M176.412,133.09a.453.453,0,0,0,.472-.424.444.444,0,0,0-.472-.415.452.452,0,0,0-.472.423.444.444,0,0,0,.472.417",
    transform: "translate(-150.644 -113.235)",
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27730",
    "data-name": "Path 27730",
    d: "M192,143.068a.673.673,0,0,0,.7-.63.661.661,0,0,0-.7-.618.671.671,0,0,0-.7.63.659.659,0,0,0,.7.618",
    transform: "translate(-163.795 -121.429)",
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27731",
    "data-name": "Path 27731",
    d: "M235.512,180.839a.45.45,0,0,0,.47-.423.443.443,0,0,0-.47-.417.452.452,0,0,0-.472.424.443.443,0,0,0,.472.415",
    transform: "translate(-201.246 -154.12)",
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27732",
    "data-name": "Path 27732",
    d: "M246.89,146.7a.613.613,0,0,0,.64-.575.6.6,0,0,0-.64-.564.612.612,0,0,0-.64.574.6.6,0,0,0,.64.565",
    transform: "translate(-210.845 -124.631)",
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27733",
    "data-name": "Path 27733",
    d: "M251.23,167.989a.775.775,0,0,0,.824.728.79.79,0,0,0,.822-.74.775.775,0,0,0-.822-.726.79.79,0,0,0-.824.739",
    transform: "translate(-215.109 -143.203)",
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27734",
    "data-name": "Path 27734",
    d: "M267.253,138.676a.791.791,0,0,0,.824-.74.775.775,0,0,0-.824-.726.789.789,0,0,0-.822.739.775.775,0,0,0,.822.727",
    transform: "translate(-228.123 -117.482)",
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27735",
    "data-name": "Path 27735",
    d: "M273.92,155.943a.445.445,0,0,0,.471.417.453.453,0,0,0,.47-.424.442.442,0,0,0-.47-.416.451.451,0,0,0-.471.423",
    transform: "translate(-234.536 -133.159)",
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27736",
    "data-name": "Path 27736",
    d: "M288.892,168.4a.492.492,0,0,0,.513-.46.482.482,0,0,0-.513-.453.491.491,0,0,0-.512.46.481.481,0,0,0,.512.453",
    transform: "translate(-246.917 -143.408)",
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27737",
    "data-name": "Path 27737",
    d: "M296.3,148.323a.491.491,0,0,0,.512-.46.481.481,0,0,0-.512-.453.492.492,0,0,0-.513.46.482.482,0,0,0,.513.453",
    transform: "translate(-253.262 -126.216)",
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27738",
    "data-name": "Path 27738",
    d: "M147.868,202.8c-7.433,1.265-12.895,1.1-17.469,1.252-2.4.082-.685,2.376-2.444,2.554a3.651,3.651,0,0,1-.929.043c-.78-.073-.687-.243-1.094-.869-.451-.693-1.179-1.353-1.64.975.007,1.225-3.286,1.856-3.321-1.675-.063-1.623-.267-1.951-2.132-2.294-1.749-.223-1.579,1.007-1.409,2.553.253,3.53,7.415,3.431,10.19,3.618,6.619.446,15.966.3,20.937-1.834,2.057-.86,1.65-4.82-.689-4.322",
    transform: "translate(-100.459 -173.608)",
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27739",
    "data-name": "Path 27739",
    d: "M147.116,242.45c-1.49.622-2.2,2.314-3.452,3.682-.5.665-.951.5-1.673.2-2.059-1.426-3.958-2.979-8.143-2.744l-8.2-.553c-.412,2.552-3.65,2.719-2.962-.282l-2.485-.544c-1.8-.245-2.319,3.287-.195,4.193,3.168,1.807,24.355,3.445,30.107-.95,1.7-1.832-.092-4.428-3-3",
    transform: "translate(-101.565 -207.238)",
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27740",
    "data-name": "Path 27740",
    d: "M126.1,275.086a21.123,21.123,0,0,0,5.09.221c1.721-.128,1.395-.935.3-1.029-5.166-.722-7.629-.38-9.761-2.3-.789-.689-1.6-.362-1.459.587.157,2.221,1.493,4.909,6.007,6.145,6.312,1.625,18.667,1.474,23-1.7a6.056,6.056,0,0,0,2.464-4.566c.18-2.885-1.582-1.2-1.555.011-2.1,1.076-4.276.848-6.078.931-.612-.053-.788.819-.08.855a23.607,23.607,0,0,0,3.118-.057c2.454-.18,2,1.912-.124,2.4-6.892,2.137-15.954,1.684-21.077.47-1.647-.406-2.674-2.34.161-1.972",
    transform: "translate(-102.957 -231.91)",
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27741",
    "data-name": "Path 27741",
    d: "M387.449,137.331l3.173-1.241.026.068-2.844,2.08.523,1.339,2.934-2.513a1.323,1.323,0,0,0,1.612.3l1.085-.426a1.465,1.465,0,0,0,1.018-2.1l-.63-1.61L386.97,136.1Zm6.2-2.424.109.276c.093.242,0,.415-.279.526l-1.087.424a.409.409,0,0,1-.486-.076,1.121,1.121,0,0,1-.122-.25l-.057-.148Z",
    transform: "translate(-331.332 -114.066)",
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27742",
    "data-name": "Path 27742",
    d: "M336.207,54.264a1.513,1.513,0,0,0,2.413-.181l1.964-2.277-1.257-1.083-.827.959.257.223-1.136,1.318q-.291.339-.589.083c-.194-.168-.2-.367,0-.592l3.1-3.6c.194-.227.388-.256.582-.089l.006.006c.194.17.2.367,0,.591l-.733.851,1,.861.733-.851a1.708,1.708,0,1,0-2.588-2.23l-3.1,3.6a1.51,1.51,0,0,0,.174,2.41",
    transform: "translate(-287.275 -40.723)",
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27743",
    "data-name": "Path 27743",
    d: "M366.463,92.339l1.028-.733-1.038-1.452,1.681-1.2.891,1.249,1.031-.736-.891-1.249,1.679-1.2,1.038,1.454,1.028-.735-1.8-2.525-6.446,4.605Z",
    transform: "translate(-312.23 -72.959)",
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27744",
    "data-name": "Path 27744",
    d: "M50.991,88.644l-1.028-.732-1.035,1.454-1.682-1.2.89-1.251L47.1,86.184l-.89,1.251-1.682-1.2,1.035-1.455-1.028-.732-1.8,2.526,6.453,4.6Z",
    transform: "translate(-36.595 -71.965)",
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27745",
    "data-name": "Path 27745",
    d: "M82.627,51.062a2.262,2.262,0,0,0,2.052.709q1.242-.114,1.587.283l.581.669c.194.224.2.423,0,.592s-.394.144-.588-.081l-.738-.85-.995.864.736.85a1.708,1.708,0,1,0,2.579-2.24l-.644-.74a2.237,2.237,0,0,0-2.032-.687q-1.242.114-1.559-.25l-.462-.532c-.2-.226-.2-.421,0-.589l.007-.006c.2-.167.391-.139.585.085l.736.848.995-.864-.736-.848a1.708,1.708,0,1,0-2.579,2.239Z",
    transform: "translate(-69.893 -40.742)",
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27746",
    "data-name": "Path 27746",
    d: "M25.37,139.166a1.491,1.491,0,0,0-.976-2.172l-1.088-.431a1.1,1.1,0,0,0-1.2.092,1.1,1.1,0,0,0-.808-.89l-1.084-.431a1.466,1.466,0,0,0-2.181.845l-.673,1.694,7.361,2.926Zm-4.338-1.524-.093.236-1.919-.762.145-.365q.144-.36.562-.194l1.086.431a.407.407,0,0,1,.3.388,1,1,0,0,1-.081.266m3.147,1.1-.145.365-1.918-.763.093-.236a.984.984,0,0,1,.127-.247.4.4,0,0,1,.483-.076l1.088.431c.278.111.367.286.272.526",
    transform: "translate(-14.864 -115.713)",
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27747",
    "data-name": "Path 27747",
    d: "M250.91,8.223a1.513,1.513,0,0,0,1.987-1.38L254.029.61l-1.3-.234L251.6,6.608c-.053.292-.207.417-.465.37s-.355-.217-.3-.509l1.13-6.233L250.669,0l-1.13,6.234a1.509,1.509,0,0,0,1.372,1.988",
    transform: "translate(-213.62)",
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27748",
    "data-name": "Path 27748",
    d: "M294.878,19.217l.066.029-.577,3.478,1.311.589.338-3.849a1.324,1.324,0,0,0,1.359-.916l.479-1.064a1.465,1.465,0,0,0-.748-2.216l-1.576-.709-3.251,7.223,1.2.541Zm1.336-2.966.27.122q.354.16.168.571l-.479,1.064a.408.408,0,0,1-.4.285,1.047,1.047,0,0,1-.262-.093l-.145-.065Z",
    transform: "translate(-250.256 -12.467)",
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27749",
    "data-name": "Path 27749",
    d: "M127.415,17.325l2.743,6.067,1.2-.542-2.745-6.067.956-.433-.52-1.15-3.11,1.406.52,1.152Z",
    transform: "translate(-107.833 -13.015)",
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27750",
    "data-name": "Path 27750",
    d: "M198.96,7.923a1.49,1.49,0,0,0,1.433-1.9L200.25,4.86a1.1,1.1,0,0,0-.658-1.006,1.1,1.1,0,0,0,.391-1.139l-.144-1.157q-.211-1.7-1.79-1.5L196.24.278l.978,7.862Zm-.017-2.9.145,1.162c.036.3-.075.46-.331.492l-.39.047-.254-2.049.252-.032a.928.928,0,0,1,.279-.007.4.4,0,0,1,.3.387m-.851-3.7c.256-.032.4.1.44.4l.145,1.157a.412.412,0,0,1-.2.453,1.117,1.117,0,0,1-.273.056l-.252.032L197.7,1.369Z",
    transform: "translate(-168.025 -0.029)",
    fill: "#fcbf49"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/header-logo.8b4661e9d9939b11160716bd7aee0e3a.svg";
export { ForwardRef as ReactComponent };